import React from 'react'
import { connect } from 'react-redux'
import { setPaginationFields } from '../../actions'
import LeftChevronSVG from '../icons/LeftChevronSVG'
import RightChevronSVG from '../icons/RightChevronSVG'

const Paginator = props => {
  const category = props[props.category]

  const handlePreviousPage = () => {
    if (category.page === 1) {
      return
    }

    props.setPaginationFields({
      reducerProp: category,
      data: { page: category.page - 1 },
    })

    handlePaginate(category.page - 1)
  }

  const handleNextPage = () => {
    if (category.page + 1 > category.pages) {
      return
    }

    props.setPaginationFields({
      reducerProp: category,
      data: { page: category.page + 1 },
    })

    handlePaginate(category.page + 1)
  }

  const handlePaginate = page => {
    props.handlePaginate(page)
  }

  return (
    <div className="dealmed-paginator">
      <div className="dealmed-paginator__buttons" style={{ display: 'flex', gap: '12px' }}>
        <button
          type="button"
          className="dealmed-paginator__button dealmed-paginator__button--previous"
          disabled={category.page === 1}
          onClick={handlePreviousPage}
        >
          <span className="visually-hidden">Previous</span>
          <LeftChevronSVG />
        </button>
        <p
          className="dealmed-paginator__page"
          style={{ fontFamily: 'IBM Plex Sans', fontSize: '14px', color: '#464041' }}
        >
          Page {category.page} of {category.pages}
        </p>
        <button
          type="button"
          className="dealmed-paginator__button dealmed-paginator__button--next"
          disabled={category.page === category.pages}
          onClick={handleNextPage}
        >
          <span className="visually-hidden">Next</span>
          <RightChevronSVG />
        </button>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  return state.paginate
}

export default connect(mapStateToProps, { setPaginationFields })(Paginator)
